import OsanoConsentObject from '@alltrails/types/OsanoConsentObject';

function parseConsent(atOsanoCookieValue: string): OsanoConsentObject | undefined {
  try {
    return JSON.parse(atOsanoCookieValue).consent;
  } catch {
    return undefined;
  }
}

/**
 * Checks whether marketing cookies are allowed based on the raw `at_osano` cookie value.
 */
export function canSetMarketingCookies(atOsanoCookieValue: string | undefined): boolean {
  if (!atOsanoCookieValue) {
    return false;
  }

  const consentObj = parseConsent(atOsanoCookieValue);
  if (!consentObj) {
    return false;
  }

  return consentObj.MARKETING !== 'DENY' && consentObj.OPT_OUT !== 'ACCEPT';
}

export function marketingConsentEnabled(atOsanoCookieValue: string | undefined): boolean {
  if (!atOsanoCookieValue) {
    return false;
  }

  const consentObj = parseConsent(atOsanoCookieValue);
  if (!consentObj) {
    return false;
  }

  return consentObj.MARKETING === 'ACCEPT';
}
